<template>
    <div>
        <nav-breadcrumb :menu="[{label:  '申贷意向详情'}]"/>

        <el-row>
            <el-col>
                <panel label="基本信息">
                    <form-build
                        :form-data="dealerForm"
                        :form-rules="dealerFormRules"
                        :form-columns="columns"
                        class="formTable"
                        form-name="formSubmit2" ref="formBuildName2"
                    />
                </panel>
            </el-col>
        </el-row>
        <div class="tr xzmt">
            <el-button @click="$router.back()">返回</el-button>
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import Status2CN from "../../filters/Status2CN";
    import {formatMoney} from "../../filters/CommonFilters";
    import moment from 'moment'
    export default {
        name: "FinancingRequestView",
        data(){
            return {
                columns:[
                    {
                        label: '客户名称',
                        field: 't__customerName',

                    },
                    {
                        label: '手机号',
                        field: 't__customerContactNo',

                    },
                    {
                        label: '申贷金额',
                        field: 't__amount',
                        formatter: (c,v) => {
                            return formatMoney(v)
                        },
                    },
                    {
                        label: '年限',
                        field: 't__repaymentCount',
                        formatter: function (c,v) {
                            return v/12+"年"
                        }

                    },
                    {
                        label: '房产位置',
                        field: 't__propertyOwner',
                        formatter: function (r,v) {
                            let val = ''
                            if( r.t__propertyOwner)
                                val= val + r.t__propertyOwner
                            if( r.t__propertyLocation)
                                val= val + r.t__propertyLocation
                            if( r.t__propertyLocationRef)
                                val= val + r.t__propertyLocationRef
                            if( r.t__propertyLocationCity)
                                val= val + r.t__propertyLocationCity

                            return val
                        }

                    },
                    {
                        label: '房产面积',
                        field: 't__propertyArea',
                        field: 't__repaymentCount',
                        formatter: function (r,v) {
                            return v+"㎡"
                        }

                    },
                    {
                        label: '借款用途',
                        field: 't__purpose',
                        span:24
                    },
                    {
                        label: '状态',
                        field: 't__requestStatus',
                        formatter: function ( r, v) {
                            return Status2CN('Request__'+v)
                        }

                    },
                    {
                        label: '分配渠道商',
                        field: 'd__dealerName',

                    },
                    {
                        label: '申请时间',
                        field: 't__requestDate',
                        formatter: function (r,v) {
                            return moment(v).format('YYYY-MM-DD HH:mm:ss')
                        },span:24

                    },
                ],
                requestId: this.$route.query['requestId']||'',
                dealerForm:{
                },
                deviceTypeOptions : [],
                dealerFormRules: {},
            }
        },
        mounted() {
            if(this.requestId){
                this.getData()
            }
        },
        filters:{
            Status2CN
        },
        methods:{
            getData:function(){
                xhr.getFinancingRequest({
                        't.requestId': this.requestId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.dealerForm = res.data.data
                            }
                        }catch (e) {

                        }
                    })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FinancingRequestView.vue